import * as React from 'react'
import Logo from './logo'
import {
  AppBar,
  Toolbar,
  Avatar,
  Icon,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { Router } from 'routes'
import { useTranslation } from 'i18n'
import { useCurrentUser } from 'utils/context/UserContext'
import Link from 'next/link'
import NewItemActionSheet from 'components/ActionSheet/NewItemActionSheet'

type Props = {
  onLogout: (any) => void
}

const Component: React.FC<Props> = ({ onLogout }) => {
  const { t } = useTranslation('components')
  const [menuAnchor, setMenuAnchor] = React.useState(null)
  const closeMenu = () => setMenuAnchor(null)
  const openMenu = e => setMenuAnchor(e.currentTarget)

  const { currentUser } = useCurrentUser()

  return (
    <div style={{ position: 'relative' }}>
      <AppBar
        position="static"
        style={{
          backgroundColor: '#4F5B62',
        }}
      >
        <Toolbar style={{ display: 'flex' }}>
          <div style={{ flexGrow: 1 }}>
            <Link href="/artist/dashboard">
              <a>
                <Logo color="#FFF" height="2em" width="6em" />
              </a>
            </Link>
          </div>
          <div>
            <IconButton
              onClick={() => {
                if (window.Intercom) window.Intercom('show')
              }}
            >
              <Icon style={{ color: '#FFF' }}>help_outline</Icon>
            </IconButton>
            <IconButton
              aria-owns={menuAnchor ? 'accout-menu' : undefined}
              aria-haspopup="true"
              onClick={openMenu}
            >
              <Avatar
                src={currentUser?.photoURL}
                style={{ backgroundColor: '#B0B0B0' }}
              >
                {!currentUser?.photoURL && <Icon>person</Icon>}
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={menuAnchor}
              id="account-menu"
              open={!!menuAnchor}
              onClose={closeMenu}
            >
              <MenuItem onClick={() => Router.pushRoute('artistDashboard')}>
                {t('AppBar.Artist.dashboard')}
              </MenuItem>
              <NewItemMenu title={t('AppBar.Artist.createNewCard')} />
              <MenuItem onClick={() => Router.pushRoute('resources')}>
                {t('AppBar.Artist.resourceManagement')}
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('store')}>
                {t('AppBar.Artist.itemList')}
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('artistPosts')}>
                {t('AppBar.Artist.postList')}
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('orderHistory')}>
                {t('AppBar.Artist.orderHistory')}
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('sales')}>
                {t('AppBar.Artist.revenueManagement')}
              </MenuItem>
              <MenuItem onClick={() => Router.pushRoute('artistAccount')}>
                {t('AppBar.Artist.accountSetting')}
              </MenuItem>
              <Link passHref href="/artist/logout">
                <MenuItem component="a">{t('logout')}</MenuItem>
              </Link>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )
}

const NewItemMenu = ({ title }) => {
  const [modal, setModal] = React.useState(false)

  return (
    <>
      <MenuItem onClick={() => setModal(true)}>{title}</MenuItem>
      <NewItemActionSheet open={modal} onClose={() => setModal(false)} />
    </>
  )
}

export default Component
